import React from "react";

const InboxIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 16.91 16.5889"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2795,12.728h-4.21c-0.2099,0 -0.38,0.171 -0.38,0.38v0.92c0,0.21 0.1701,0.38 0.38,0.38h4.21c0.2098,0 0.38,-0.17 0.38,-0.38v-0.92c0,-0.209 -0.1702,-0.38 -0.38,-0.38z"
        fill="#1A8B5A"
      />
      <path
        d="M15.7101,7.769c0,-0.74 -0.6,-1.35 -1.34,-1.37c-0.62,-0.02 -1.23,0.16 -1.77,0.51l-3.18,2.09c-0.59,0.39 -1.36,0.39 -1.96,0l-3.18,-2.09c-0.54,-0.35 -1.15,-0.53 -1.77,-0.51c-0.74,0.02 -1.34,0.63 -1.34,1.37l-0.25,-1.36c-0.16,-0.83 0.48,-1.61 1.33,-1.61h12.37c0.85,0 1.49,0.77 1.33,1.61l-0.25,1.36z"
        fill="currentColor"
      />
      <path
        d="M14.58,5.569c0.62,0 1.13,0.51 1.13,1.13v7.56c0,0.62 -0.51,1.13 -1.13,1.13h-12.25c-0.62,0 -1.13,-0.51 -1.13,-1.13v-7.56c0,-0.62 0.51,-1.13 1.13,-1.13zM14.58,4.369h-12.25c-1.29,0 -2.33,1.05 -2.33,2.33v7.56c0,1.29 1.04,2.33 2.33,2.33h12.25c1.29,0 2.33,-1.04 2.33,-2.33v-7.56c0,-1.28 -1.04,-2.33 -2.33,-2.33z"
        fill="currentColor"
      />
      <path
        d="M15.91,4.789h-14.91l6.43,-4.47c0.61,-0.42 1.42,-0.43 2.03,0l6.44,4.47z"
        fill="currentColor"
      />
    </svg>
  );
};

export default InboxIcon;
